import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { AssetsRoute } from './assets.route';

export const requestAssets = async (): Promise<unknown> =>
  cuverseApi.get(AssetsRoute.Assets()).then((res) => {
    return res?.data;
  });
